import script from "./CouponInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./CouponInfo.vue?vue&type=script&lang=ts&setup=true"

import "./CouponInfo.vue?vue&type=style&index=0&id=d74b045a&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d74b045a"]])

export default __exports__